import { useEffect } from 'react';
import { useAtom, useAtomValue } from 'jotai';
import myFiberImg from '../../Assets/AlertIcon/myFiber.svg';
import leasedFibeImg from '../../Assets/AlertIcon/leasedFiber.svg';
import rowFiberImg from '../../Assets/AlertIcon/row.svg';

import { myFiber, leasedFiber, rowFiber, kmzNetwork } from '../../common/atom/atoms';
const PartnerAndNetwrokButtons = () => {
  const [myFibers, setMyFibers] = useAtom(myFiber);
  const [leasedFibers, setLeasedFibers] = useAtom(leasedFiber);
  const [rowFibers, setRowFibers] = useAtom(rowFiber);
  const currentNetwork = useAtomValue(kmzNetwork);

  // Determine which buttons to show based on network type
  const shouldShowMyFiber = currentNetwork === 'IPRAN';
  const shouldShowLeasedFiber = currentNetwork === 'FTTS' || currentNetwork === 'IPRAN';
  const shouldShowRow = false; // Never show RoW button based on requirements

  // Automatically set button states based on network type
  useEffect(() => {
    if (currentNetwork === 'FTTS') {
      // FTTS: Only Leased Fiber button is shown, so set it to true, others to false
      setMyFibers(false);
      setLeasedFibers(true);
      setRowFibers(false);
    } else if (currentNetwork === 'IPRAN') {
      // IPRAN: My Fiber and Leased Fiber buttons are shown, so set both to true, RoW to false
      setMyFibers(true);
      setLeasedFibers(true);
      setRowFibers(false);
    } else if (currentNetwork === 'MPBN' || currentNetwork === 'OTN') {
      // MPBN and OTN: No buttons shown, but set states to true so links and sites are displayed
      // We set both to true to ensure all data is shown regardless of tenancy type
      setMyFibers(true);
      setLeasedFibers(true);
      setRowFibers(true);
    }
  }, [currentNetwork, setMyFibers, setLeasedFibers, setRowFibers]);

  // Don't show any buttons for MPBN and OTN
  if (currentNetwork === 'MPBN' || currentNetwork === 'OTN') {
    return null;
  }

  // Don't show container if no buttons should be displayed
  if (!shouldShowMyFiber && !shouldShowLeasedFiber && !shouldShowRow) {
    return null;
  }

  return (
    <>
      <div
        style={{
          position: 'absolute',
          bottom: '10px',
          left: '10px',
          display: 'flex',
          flexDirection: 'column',
          gap: '10px',
          zIndex: 1,
        }}
      >
        <div data-svg-wrapper style={{ marginLeft: '5px', display: 'flex', gap: '5%' }}>
          {shouldShowMyFiber && (
            <div
              style={{
                width: '100%',
                height: '100%',
                background: myFibers ? '#192126' : 'white',
                boxShadow: '0px 0px 4.72px 1.18px rgba(0, 0, 0, 0.25)',
                borderRadius: 5.67,
                outline: '2.36px rgba(0, 0, 0, 0.20) solid',
                transition: 'all 0.3s ease-in-out',
                cursor: 'pointer',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = '#A0A2A4';
                e.currentTarget.style.transform = 'scale(1.05)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = myFibers ? '#192126' : 'white';
                e.currentTarget.style.transform = 'scale(1)';
              }}
            >
              <div
                style={{
                  width: '100%',
                  height: '100%',
                  marginTop: '4px',
                  flexDirection: 'column',
                  justifyContent: 'flex-start',
                  alignItems: 'center',
                  gap: 5.67,
                  display: 'inline-flex',
                }}
                onClick={() => setMyFibers(!myFibers)}
              >
                <div
                  style={{
                    marginTop: '4px',
                    width: 34,
                    height: 34,
                    background: '#E8E9E9',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: 5.67,
                    transition: 'all 0.3s ease-in-out',
                  }}
                >
                  <div
                    style={{
                      width: 22.67,
                      height: 22.67,
                      position: 'relative',
                      overflow: 'hidden',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <img src={myFiberImg} alt="My Fiber" />
                  </div>
                </div>
                <div
                  style={{
                    width: 62.33,
                    marginBottom: '5px',
                    textAlign: 'center',
                    justifyContent: 'center',
                    display: 'flex',
                    flexDirection: 'column',
                    color: !myFibers ? 'black' : 'white',
                    fontSize: 7.93,
                    fontFamily: 'Inter',
                    fontWeight: '500',
                    wordWrap: 'break-word',
                  }}
                >
                  My Fiber
                </div>
              </div>
            </div>
          )}

          {shouldShowLeasedFiber && (
            <div
              style={{
                width: '100%',
                height: '100%',
                background: leasedFibers ? '#192126' : 'white',
                boxShadow: '0px 0px 4.72px 1.18px rgba(0, 0, 0, 0.25)',
                borderRadius: 5.67,
                outline: '2.36px rgba(0, 0, 0, 0.20) solid',
                transition: 'all 0.3s ease-in-out',
                cursor: 'pointer',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = '#A0A2A4';
                e.currentTarget.style.transform = 'scale(1.05)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = leasedFibers ? '#192126' : 'white';
                e.currentTarget.style.transform = 'scale(1)';
              }}
            >
              <div
                style={{
                  width: '100%',
                  height: '100%',
                  marginTop: '4px',
                  flexDirection: 'column',
                  justifyContent: 'flex-start',
                  alignItems: 'center',
                  gap: 5.67,
                  display: 'inline-flex',
                }}
                onClick={() => setLeasedFibers(!leasedFibers)}
              >
                <div
                  style={{
                    marginTop: '4px',
                    width: 34,
                    height: 34,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    transition: 'all 0.3s ease-in-out',
                    background: '#E8E9E9',
                    borderRadius: 5.67,
                  }}
                >
                  <div
                    style={{
                      width: 22.67,
                      height: 22.67,
                      position: 'relative',
                      overflow: 'hidden',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <img src={leasedFibeImg} alt="Leased Fiber" />
                  </div>
                </div>
                <div
                  style={{
                    width: 67.33,
                    marginBottom: '5px',
                    textAlign: 'center',
                    justifyContent: 'center',
                    display: 'flex',
                    flexDirection: 'column',
                    color: !leasedFibers ? 'black' : 'white',
                    fontSize: 7.93,
                    fontFamily: 'Inter',
                    fontWeight: '500',
                    wordWrap: 'break-word',
                  }}
                >
                  Leased Fiber
                </div>
              </div>
            </div>
          )}

          {shouldShowRow && (
            <div
              style={{
                width: '100%',
                height: '100%',
                background: rowFibers ? '#192126' : 'white',
                boxShadow: '0px 0px 4.72px 1.18px rgba(0, 0, 0, 0.25)',
                borderRadius: 5.67,
                outline: '2.36px rgba(0, 0, 0, 0.20) solid',
                transition: 'all 0.3s ease-in-out',
                cursor: 'pointer',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = '#A0A2A4';
                e.currentTarget.style.transform = 'scale(1.05)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = rowFibers ? '#192126' : 'white';
                e.currentTarget.style.transform = 'scale(1)';
              }}
            >
              <div
                style={{
                  width: '100%',
                  height: '100%',
                  marginTop: '4px',
                  flexDirection: 'column',
                  justifyContent: 'flex-start',
                  alignItems: 'center',
                  gap: 5.67,
                  display: 'inline-flex',
                }}
                onClick={() => setRowFibers(!rowFibers)}
              >
                <div
                  style={{
                    marginTop: '4px',
                    width: 34,
                    height: 34,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    transition: 'all 0.3s ease-in-out',
                    background: '#E8E9E9',
                    borderRadius: 5.67,
                  }}
                >
                  <div
                    style={{
                      width: 22.67,
                      height: 22.67,
                      position: 'relative',
                      overflow: 'hidden',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <img src={rowFiberImg} alt="Row" />
                  </div>
                </div>
                <div
                  style={{
                    width: 67.33,
                    marginBottom: '5px',
                    textAlign: 'center',
                    justifyContent: 'center',
                    display: 'flex',
                    flexDirection: 'column',
                    color: !rowFibers ? 'black' : 'white',
                    fontSize: 7.93,
                    fontFamily: 'Inter',
                    fontWeight: '500',
                    wordWrap: 'break-word',
                  }}
                >
                  RoW
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default PartnerAndNetwrokButtons;
